import * as React from 'react';
import { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import StarsIcon from '@mui/icons-material/Stars';
import { IconByCategory } from '@shared/components/IconByCategory';
import { Category } from '@interfaces/caetgory';
import { Theme } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

import useMediaQuery from '@mui/material/useMediaQuery';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        '&$selected': {
            backgroundColor: `${theme.palette.primary.dark} !important`,
            color: 'white !important',
            '& button': {
                color: 'white !important',
            }
        },
    },
    selected: {},
}));

export default function CategoriesList({ categories, click, selectedIndex }: { categories: Array<Category>, click: Function, selectedIndex?: string }) {
    const classes = useStyles();

    const theme = useTheme();
    const smallScreen = useMediaQuery(theme.breakpoints.down('md'));
    const [category, setCategory] = useState('all');

    const handleChange = (event: SelectChangeEvent) => {
        setCategory(event.target.value);
        click(event.target.value)
    };

    useEffect(() => {
        click('all')
    }, [])

    const list = smallScreen
        ? <FormControl sx={{ m: 1, minWidth: 355 }}>
            <Select
                value={category}
                onChange={handleChange}
            >
                <MenuItem
                    classes={{ root: classes.root, selected: classes.selected }}
                    selected={selectedIndex === 'all'}
                    value={'all'}//change this
                >
                    <Box sx={{ display: 'flex', alignItems: 'center'}}>
                        <ListItemIcon>
                            <StarsIcon />
                        </ListItemIcon>
                        <ListItemText primary='All' />
                    </Box>
                </MenuItem>
                {
                    categories.map(item => {
                        return <MenuItem
                            classes={{ root: classes.root, selected: classes.selected }}
                            selected={selectedIndex === item.id}
                            value={item.id}
                            key={item.id}
                        >
                            <Box sx={{ display: 'flex', alignItems: 'center'}}>
                                <ListItemIcon>
                                    <IconByCategory category={item.name} />
                                </ListItemIcon>
                                <ListItemText primary={item.name} />
                            </Box>
                        </MenuItem>
                    })
                }
            </Select>
        </FormControl>
        : <List>
            <ListItem disablePadding classes={{ root: classes.root, selected: classes.selected }} selected={selectedIndex == 'all'} onClick={() => click('all')}>
                <ListItemButton>
                    <ListItemAvatar>
                        <StarsIcon  style={{color:'green'}} />
                    </ListItemAvatar>
                    <ListItemText primary={`All`} />
                </ListItemButton>
            </ListItem>
            {categories.map((item) => {
                return (
                    <ListItem
                        disablePadding
                        classes={{ root: classes.root, selected: classes.selected }}
                        selected={selectedIndex == item.id}
                        onClick={() => click(item.id)}
                        key={item.id}
                        secondaryAction={
                            <strong>{item?.count}</strong>
                        }
                    >
                        <ListItemButton>
                            <ListItemAvatar>
                                <IconByCategory style={{color:'green'}} category={item.name} />
                            </ListItemAvatar>
                            <ListItemText primary={item.name} />
                        </ListItemButton>
                    </ListItem>
                );
            })}
        </List>

    return list;
}
